<template>

<video width="300" controls autoplay >
    <source :src="myVideo" />

</video>
   

</template>

<script>
export default {
    name: "myVideo",
    data() {
        return {
            myVideo : "https://litago.mediafarm.no/prpg/testvideo/725_919.mp4"
        }
  },
  methods:{
    changeVideo(){
        console.log("Change video")
      this.myVideo = "https://litago.mediafarm.no/prpg/testvideo/821_919.mp4"
    }
  }
    
}
</script>